import React, {Fragment} from "react";
import './floatingnumber.css';


function FloatingNumber(){
    return(
        <Fragment>
<div className="btn-wrap2"><a className="floating-btn2" href="tel:+918448894369">< i className="bi bi-telephone-forward-fill"> Call Us</i></a>
  <div className="shadow2"></div>
</div>
        </Fragment>
    )
};

export default FloatingNumber;